import React, {  useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoBlack from "../../../image/logo/logoBlack.webp"
import iconInsta from "../../../image/iconReseaux/IconInsta.webp"
import iconFacebook from "../../../image/iconReseaux/IconFacebook.webp"
import iconLinkedin from "../../../image/iconReseaux/IconLinkedin.webp"
import { FiChevronDown, FiChevronUp, FiChevronRight } from "react-icons/fi";
import "./Footer.css"
import { AppContext } from "../../../context/AppContext";
import { baseDays, cityWithPreposition, formatDateToYMD, Restaurant, slugify,faqBase, cityWithOtherPreposition , faqProx} from "../../../components/types/types";
import { MdOutlineStar } from "react-icons/md";

const topCities = [
{ name: "Les meilleurs restaurants à Angers", url: "https://www.quelresto.fr/angers" },
  { name: "Les meilleurs restaurants à Brissac-Loire-Aubance", url: "https://www.quelresto.fr/brissac-loire-aubance" },
  { name: "Les meilleurs restaurants à Mûrs-Erigné", url: "https://www.quelresto.fr/murs-erigne" },
  { name: "Les meilleurs restaurants aux Ponts-de-Cé", url: "https://www.quelresto.fr/les-ponts-de-ce" },
  { name: "Les meilleurs restaurants à proximité", url: "https://www.quelresto.fr/restaurants-a-proximite" },
];

interface FooterProps {
    cityLoad?:string,
    isResto?:boolean,
    listRestoLoad?:Restaurant[],
    maskCookie?:boolean,
    isHomePage?:boolean
}

const Footer:React.FC<FooterProps> = ({cityLoad='',isResto=false,listRestoLoad,maskCookie=false,isHomePage=false}) => {
    const [currentResponse,setCurrentResponse] = useState(-1)
    const {setShowCookies,setPreferencesCookies,isLogin,setCookiesFromFooter} = useContext(AppContext)
    const isProximity = cityLoad === 'à proximité';
    const currentYear = new Date().getFullYear();
    const location = useLocation();
    const currentPath = location.pathname;
    const top4ForThisPage = useMemo(() => {
        return topCities
            .filter(c => {
                try {
                    return new URL(c.url).pathname !== currentPath;
                } catch {
                    return true;
                }
            })
            .slice(0, 4);
    }, [currentPath]);
    const handleResponse = (id:number) => {
        if(currentResponse === id) setCurrentResponse(-1)
        else setCurrentResponse(id)
    }
    const faqCities = [[`Comment trouver facilement un restaurant ${cityLoad} et ses alentours`,`Sur QuelResto, vous pouvez comparer facilement tous les restaurants ${cityLoad} grâce aux cartes, photos, horaires et avis disponibles sur chaque restaurant. Pour explorer aussi les restaurants à proximité ${cityWithOtherPreposition(cityLoad)}, utilisez les pages dédiées aux villes voisines ou naviguez dans la liste complète des établissements référencés.`],
     [`Où voir la carte, les photos et les avis des restaurants ${cityLoad}`,`Sur QuelResto, chaque restaurant ${cityLoad} dispose d’une page complète avec sa carte, ses photos, ses horaires et les avis clients. Vous pouvez ainsi comparer facilement les restaurants ${cityLoad} et choisir l’adresse qui correspond le mieux à vos envies.`],
     [`Comment trouver un restaurant pas cher, romantique, avec terrasse, concrètement un restaurant adapté à mes envies ou à mes besoins ${cityLoad}`,`QuelResto vous permet de filtrer les restaurants ${cityLoad} selon vos besoins et envies. Vous pouvez par exemple trouver un restaurant pas cher, un restaurant romantique, un restaurant avec terrasse, ou encore choisir selon le budget, l’ambiance, un régime alimentaire (végétarien, végan, halal, sans gluten) ou des options pratiques comme l’accessibilité PMR ou le parking. L’ensemble des filtres disponibles vous permet ainsi de comparer facilement les restaurants ${cityLoad} et de trouver l’adresse la plus adaptée à vos envies et à vos besoins.`],
     [`Peut-on réserver un restaurant en ligne ${cityLoad}`,`Sur chaque page restaurant ${cityLoad}, vous retrouvez une section réservation avec le numéro de téléphone du restaurant. Si l’établissement propose une réservation en ligne via son propre outil, un lien pour y accéder est affiché. À l’avenir, QuelResto intégrera sa propre réservation en ligne pour réserver rapidement et avoir des avis vérifiés. Vous pourrez ainsi réserver un restaurant ${cityLoad} en quelques clics, simplement et en toute confiance.`]]
   
     const norm = (s?: string) =>
    (s ?? "")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .toLowerCase().trim();

    const counts = React.useMemo(() => {
        const list = Array.isArray(listRestoLoad) ? listRestoLoad : [];
        const targetCity = norm(cityLoad || ""); 

        const today = new Date();
        const ymd = formatDateToYMD(today);
        const dayKeyStr = baseDays[today.getDay()];

        let exactCity = 0;
        let ouvriers = 0;
        let cheques = 0;
        let openToday = 0;

        for (const r of list) {
            const city = norm(cityWithPreposition(r.address?.[1]));
            if (targetCity && city === targetCity) exactCity++;
            const f = r.filters ?? [];
            if (f.some(x => x==='Menu ouvrier')) ouvriers++;
            if (f.some(x => x==='Chèque-vacances')) cheques++;

            let isOpen = false;
            const sd = r.special_date?.[ymd];
            if (sd && sd[0]) {
            isOpen = true;
            } else {
            const ranges = r.schedule?.[dayKeyStr];
            if (Array.isArray(ranges) && ranges.length > 0) isOpen = true;
            }
            if (isOpen) openToday++;
        }
        if(isProximity) exactCity = listRestoLoad?.length || exactCity;
        return { numberExactCity: exactCity, numberOuvrier: ouvriers, numberCheques: cheques, numberOpenToday: openToday };
    }, [listRestoLoad, cityLoad]);

    const [page, setPage] = useState(0);        
    const [dir, setDir] = useState<1 | -1>(1); 
    const [leaving, setLeaving] = useState<number | null>(null);
    const pageSize = 4;
    const pages = useMemo(() => [faqBase.slice(0, pageSize), faqBase.slice(pageSize)], [faqBase, pageSize]);

    const go = (next: 0 | 1) => {
        if (next === page) return;
        setDir(next > page ? 1 : -1);
        setLeaving(page);
        setPage(next);
        setCurrentResponse(-1)
    };

    return (
        <>
        {
        !isResto && 
        <div className="prefFooterHome primaryBack" style={{...(maskCookie ? {zIndex:105} : {}),...(!isHomePage ? {display:'none'} : {})}}>
            {cityLoad && cityLoad !== '' ? <>
                { !isProximity ?
                <>
                <div className="listCity">
                    <h2 className="smallTextBold" style={{whiteSpace:'nowrap'}}>Les meilleurs restaurants dans d’autres villes&nbsp;:</h2>
                    {top4ForThisPage.map((c,id) => (
                        <React.Fragment key={c.url}>
                        <a href={c.url} className="smallText">{c.name}</a>
                        {id !== top4ForThisPage.length-1 && <div className="border"></div>}
                        </React.Fragment>
                    ))}
                </div>
                <div className="separationListCity"></div></>:
                <h2 className="smallTitle titleProx">Restaurants à proximité : cette page vous permet de trouver facilement, grâce à votre position, les meilleures adresses autour de vous. Découvrez en un coup d’œil des restaurants sélectionnés pour leur qualité et leur authenticité.</h2>}
                <div className={`contentCity smallText ${isProximity ? 'contentProx' : ''}`}>
                    <div className="block">
                        <h2>Infos pratiques sur les restaurants {cityLoad}{!isProximity && ' et ses alentours'}&nbsp;:</h2>
                        <div className="list XsmallText">
                            <div className="elem">-<span>QuelResto référence actuellement {counts.numberExactCity} restaurant{counts.numberExactCity>1 ? 's' : ''} {cityLoad}</span></div>
                            <div className="elem">- <span>{counts.numberOuvrier} {counts.numberOuvrier>1 ? ` restaurants proposent ` : ' restaurant propose '} un menu ouvrier le midi</span></div>
                            <div className="elem">- <span>{counts.numberCheques} {counts.numberCheques>1 ? ` établissements acceptent ` : ' établissement accepte '} les chèques vacances</span></div>
                            <div className="elem">- <span>{counts.numberOpenToday} {counts.numberOpenToday>1 ? ` restaurants ${isProximity ? ' à proximité' : ''} sont ouverts ` : ` restaurant ${isProximity ? ' à proximité' : ''} est ouvert `} aujourd’hui {!isProximity ? `${cityLoad} et ses environs` : ''}</span></div>
                        </div>
                    </div>
                    <div className="separation"><div></div></div>
                    <div className={`block ${isProximity ? 'blockProx' : ''}`}>
                        {isProximity ? 
                        <h2>Les meilleurs restaurants dans d’autres villes&nbsp;:</h2> :
                        <h2>Les restaurants les mieux notés {cityLoad} et ses alentours&nbsp;:</h2>}
                        {isProximity ? <div className="list XsmallText">{top4ForThisPage.map((c,id) => {
                                return <a href={c.url} key={c.url+'forProx'} className="XsmallText elemProx">{c.name}</a>
                            })
                            }</div>:
                        <div className="list listResto XsmallText">
                            {
                                listRestoLoad && listRestoLoad.length >0 && listRestoLoad.slice(0,4).map((elem,id) => {
                                    const slugcity = slugify(elem.address[1])
                                    const slugName = slugify(elem.name)
                                    const linkResto = `/restaurant/${slugcity}/${slugName}_${elem.id_url}?src=home`
                                    
                                    return <div className="elemResto" key={'elemResto'+elem.id_url}>
                                        <span><a href={linkResto} target="_blank" className="pointer">{elem.name}</a>  
                                        {elem.note && Number(elem.note) !== 0 ? <>{' - '} { (Number(elem.note) % 1 === 0 ? Number(elem.note).toFixed(0) : Number(elem.note).toFixed(1)) }&nbsp;<MdOutlineStar  className="iconStar"  size={11} /> </> : <></>}
                                        {elem.type && elem.type[0] ? <> {' - '} {elem.type[0]} {elem.type.length > 1 ? `${elem.type[1]}` : ''}</> : ''} 
                                        {elem.cuisines && elem.cuisines[0] ? (` - Cuisine${elem.cuisines.length > 1 && elem.cuisines[1] ? 's' : ''} ${(elem.cuisines.length > 1 && elem.cuisines[1]) ? ` ${elem.cuisines[0]} et ` : ''}` )  : ''} 
                                        <span style={{whiteSpace:'nowrap'}}>{(elem.cuisines.length > 1 && elem.cuisines[1]) ? ` ${elem.cuisines[1]}` :  (elem.cuisines && elem.cuisines[0] ? elem.cuisines[0] : '')}&nbsp;-&nbsp;{Number(elem.total_price).toFixed(0) || 20}€</span></span>
                                    </div>
                                })
                            }
                        </div>}
                    </div>
                    <div className="separation"><div></div></div>
                    <div className="block">
                        <div className="containerFaq">
                            <h2 className="midTextBold">Les questions fréquentes&nbsp;:</h2>
                            <div className="faqViewport smallText"  aria-live="polite" >
                                <div
                                    key={`panel-${page}`}
                                    className='list'>
                                    {(isProximity ? faqProx : faqCities).map(([q, a], id) => (
                                        <React.Fragment key={`${page}-${id}`} >
                                            <div className={`faqItem ${currentResponse === id ? 'visible' : ''}`} >
                                                <div className="question pointer" onClick={() => handleResponse(id)}>{currentResponse === id ? <FiChevronUp className="icon" size={16}/> : <FiChevronDown className="icon" size={16}/>}<h3 className="q">{q}&nbsp;?</h3></div>
                                                <div className="answerWrap">
                                                    <div className="answer XsmallText">{a}</div>
                                                </div>
                                            </div>
                                            {id !== 3 && <div className={`border ${(currentResponse === id || currentResponse-1 === id)? 'visible' : ''}`}></div>}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            : <>
            <h2 className="smallTitle">QuelResto : trouvez facilement les meilleurs restaurants dans le Maine-et-Loire, explorez les cartes, lisez les avis et découvrez les meilleures adresses autour de vous.</h2>
            <div className="content">
                <div className="containerCity">
                    <h2 className="midTextBold">Les meilleurs restaurants par ville&nbsp;:</h2>
                    <div className="list smallText" aria-label="Villes populaires">
                        <a href="/angers" >Les meilleurs restaurants à Angers</a>
                        <a href="/brissac-loire-aubance" >Les meilleurs restaurants à Brissac-Loire-Aubance</a>
                        <a href="/les-ponts-de-ce" >Les meilleurs restaurants aux Ponts-de-Cé</a>
                        <a href="/murs-erigne" >Les meilleurs restaurants à Mûrs-Erigné</a>
                    </div>
                </div>
                <div className="separation"><div></div></div>
                <div className="containerFaq">
                    <h2 className="midTextBold">Les questions fréquentes :</h2>
                     <div className="faqViewport smallText"  aria-live="polite" >
                        <div
                            key={`panel-${page}`}
                            className={`list enter ${dir === 1 ? "fromRight" : "fromLeft"}`}
                            onAnimationEnd={(e) => {(e.currentTarget as HTMLElement).classList.remove("enter", "fromRight", "fromLeft");}}>
                            {pages[page].map(([q, a], id) => (
                                <React.Fragment key={`${page}-${id}`}>
                                    <div className={`faqItem ${currentResponse === id ? 'visible' : ''}`} >
                                        <div className="question pointer" onClick={() => handleResponse(id)}>{currentResponse === id ? <FiChevronUp className="icon" size={16}/> : <FiChevronDown className="icon" size={16}/>}<h3 className="q">{q}&nbsp;?</h3></div>
                                        <div className="answerWrap">
                                            <div className="answer XsmallText">{a}</div>
                                        </div>
                                    </div>
                                    {id !== 3 && <div className={`border ${(currentResponse === id || currentResponse-1 === id)? 'visible' : ''}`}></div>}
                                </React.Fragment>
                            ))}
                        </div>
                       
                        <div
                            key={`leaving-${leaving}`}
                            className={`list leave ${dir === 1 ? "toLeft" : "toRight"}`}
                            onAnimationEnd={(e) => {
                            setLeaving(null);
                            }}
                        >
                                {pages[page === 0 ? 1 : 0].map(([q, a], id) => (
                                <div className={`faqItem ${currentResponse === id ? 'visible' : ''}`} key={`leave-${leaving}-${id}`}>
                                    <div className="question pointer" onClick={() => handleResponse(id)}>{currentResponse === id ? <FiChevronUp className="icon" size={16}/> : <FiChevronDown className="icon" size={16}/>}<h3 className="q">{q}</h3></div>
                                    <div className="answerWrap">
                                        <div className="answer XsmallText">{a}</div>
                                    </div>
                                </div>
                                ))}
                        </div>
                    </div>
                   
                    {pages[1]?.length > 0 && (
                        <div className="XsmallText lowOpacityHover pointer turnFaq" onClick={() => go(page === 0 ? 1 : 0)} onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? go(page === 0 ? 1 : 0) : null)}>
                            <p style={{margin:0}}  aria-label={page === 0 ? "Afficher les questions suivantes" : "Afficher les questions précédentes"}>
                            Questions {page === 0 ? "suivantes" : "précédentes"} </p>
                            <FiChevronRight size={14} />
                        </div>
                    )}
                </div>
            </div>
            </>}
        </div>}
        <div className={`footerHome ${isLogin === 2 && 'footerClient'}`} style={{...(maskCookie ? {zIndex:105} : {})}}>
            <div className="logoNameFooter">
                <img className="logoFooter pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} src={logoBlack} loading="lazy" alt="logo"/>
            </div>

            {isLogin === 2 ? 
                <div className="corpFooterClient">
                    <div className="help">
                        <div className="smallTextBold"><i>Besoin d'aide :</i> </div>
                        <p className="XsmallText pointer">
                            <a style={{ color: 'black', textDecoration: 'none' }} href="mailto:service-client@quelresto.fr">
                                service-client@quelresto.fr
                            </a>
                        </p>
                    </div>
                    <div className="border"></div>
                    <Link to="/legalObligation" className="linkFooter XsmallText" > <p>Mentions et obligations légales</p> </Link> 
                </div>
                :
                <div className="corpFooter XsmallText"style={{fontSize:'14px'}}>    

                    <div className="listeElemFooter1" >
                        <Link to="/ContactezNous" className="linkFooter" > <p>Contacter QuelResto</p> </Link>
                        <Link to="/APropos" className="linkFooter"><p>À propos de QuelResto</p></Link>
                        <Link to="/contact_inscription"  className="linkFooter" > <p><strong>Inscrivez votre restaurant</strong></p> </Link>
                    </div>

                        <div className="footer-divider"></div>

                    <div className="listeElemFooter2" >
                        <Link to="/Fonctionnement" className="linkFooter"><p>Fonctionnement du site</p></Link>
                        <Link to="/PolitiqueConfidentialite" className="linkFooter"> <p>Politique de confidentialité</p> </Link>
                        <Link to="/ConditionsGeneralesUtilisation" className="linkFooter"><p>Conditions Générales d’Utilisation</p></Link>
                    </div>

                        <div className="footer-divider"></div>

                    <div className="listeElemFooter3" >
                        <Link to="/MentionsLegales" className="linkFooter"> <p>Mentions légales</p> </Link> 
                        <div className="linkFooter" onClick={() => {setShowCookies(true);setPreferencesCookies(true);setCookiesFromFooter(true)}}> <p>Gestion des cookies</p> </div>
                        <Link to="/PolitiqueCookies" className="linkFooter"> <p>Politique des cookies</p> </Link>
                    </div>   
                </div>
            }

            <div className="socialMedia">
                <div className="logoMedia pointer">
                    <img className="iconMedia pointer lowOpacityHover" loading="lazy" alt="Instagram QuelResto" src={iconInsta} onClick={() =>  window.open("https://www.instagram.com/quelresto.angers/","_blank")}/> 
                    <img className="iconMedia pointer lowOpacityHover" loading="lazy" alt="Facebook QuelResto" src={iconFacebook} onClick={() => window.open("https://www.facebook.com/profile.php?id=61572588901573","_blank")}/> 
                    <img className="iconMedia pointer lowOpacityHover" loading="lazy" alt="LinkedIn QuelResto" src={iconLinkedin} onClick={() => window.open("https://www.linkedin.com/company/quelresto/","_blank")}/> 

                </div>

                <div className="copyRights" >
                        <div className="XsmallText">© {currentYear} QuelResto - Tous droits réservés</div>
                </div>

            </div>
            
        </div>
        </>
    )
}

export default Footer